/* Boost V2 — wishlist (HC-005) */
(function(){
  'use strict';
  var KEY = 'boost_wishlist';
  function read(){ try { return JSON.parse(localStorage.getItem(KEY)||'[]'); } catch(_){ return []; } }
  function write(arr){ try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch(_){} }

  function syncBadge(){
    var list = read();
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){
      el.textContent = list.length;
      el.style.display = list.length > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
      var on = list.indexOf(btn.dataset.handle) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? '♥' : '♡';
    });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var h = btn.dataset.handle;
    if (!h) return;
    var list = read();
    var idx = list.indexOf(h);
    var wasAdded = idx === -1;
    if (wasAdded) list.push(h); else list.splice(idx,1);
    write(list);
    syncBadge();
    document.dispatchEvent(new CustomEvent(wasAdded ? 'boost:wishlist:added' : 'boost:wishlist:removed', {detail:{handle:h}}));
    if (window.gtag) gtag('event', wasAdded ? 'wishlist_add' : 'wishlist_remove', {handle:h});
  });
  syncBadge();
}());
